export default __webpack_public_path__ + "static/media/offline-icon.ca61d621.svg";